import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { EmployeeHistoryEntry } from '@kontor/shared';
import { api } from '../../api';
import { CollapsibleCard } from '../../components/CollapsibleCard';

const PAGE = 50;
const stamp = new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Berlin' });

/** Verlauf der Karte (KON-078): wer wann was getan hat. Standardmäßig zugeklappt, die Liste lädt erst beim Aufklappen. */
export function EmployeeHistory({ employeeId, version }: { employeeId: string; version: number }) {
  return (
    <CollapsibleCard title="Verlauf" storageKey="employee-history">
      <HistoryList employeeId={employeeId} version={version} />
    </CollapsibleCard>
  );
}

function HistoryList({ employeeId, version }: { employeeId: string; version: number }) {
  const [limit, setLimit] = useState(PAGE);
  const history = useQuery({
    queryKey: ['employee-history', employeeId, limit, version],
    queryFn: () => api<{ data: EmployeeHistoryEntry[]; meta: { total: number } }>('GET', `/employees/${employeeId}/history?limit=${limit}`),
  });

  return (
    <>
      <p className="muted small">Wer den Mitarbeiter angelegt, geändert und welche sensiblen Daten angezeigt hat. Es stehen nie die Werte darin.</p>
      {history.isLoading && <p className="muted">Wird geladen …</p>}
      {history.data && (
        <>
          <ul className="history-list">
            {history.data.data.map((e) => (
              <li key={e.id}>
                <span className="history-list__when">{stamp.format(new Date(e.at))}</span>
                <span>
                  <strong>{e.actorName ?? 'Unbekannt'}</strong> {e.description}
                </span>
              </li>
            ))}
          </ul>
          {history.data.data.length < history.data.meta.total && (
            <button type="button" className="btn btn--secondary btn--sm" onClick={() => setLimit((l) => l + PAGE)}>Mehr laden ({history.data.meta.total - history.data.data.length} weitere)</button>
          )}
        </>
      )}
    </>
  );
}
